import type { SearchFacetData } from 'modules/search/types/SearchFacetData';

export const salaryListedFacet = {
  id: 'salaryListedFacet',
  name: 'hasSalary',
  get title() {
    return getText('Salary Listed');
  },
  options: ['true', 'false'],
  optionTitles: {
    true: 'Yes',
    false: 'No',
  },
  type: 'boolean',
  sort: false,
} as const satisfies SearchFacetData;
